import React from "react";
import CustomerForm from "../components/CustomerForm";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import { useBookingContext } from "../context/BookingContext";
import { capitalFirstLetter, currencyFormat, sumCalculatePrice } from "../utils";
import { Link, useNavigate } from "react-router-dom";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import PlaceholderImg from "../images/components/placeholder.jpg";
import useFetch from "../hooks/useFetch";
import moment from "moment";
import Loading from "../components/Loading";
import NoFoundVehicles from "../components/NoFoundVehicles";
import usePost from "../hooks/usePost";
import InputBox from "../components/InputBox";
import usePostMultipleImage from "../hooks/usePostMultipleImage";
import Notiflix from "notiflix";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import FilterModal from "../components/FilterModal";
import PaymentPrompt from "../components/PaymentPropmt";
import Navbar2 from "../components/Navbar2";
import api from "../services/api";

function SelectVehicle() {
  const { modal, setModal, data, setData, aditionalItem, dateUsage, setDateUsage } = useBookingContext();
  const [openPaymentPopUp, setOpenPaymentPopUp] = React.useState(false);
  const [paymentLink, setPaymentLink] = React.useState("");
  const [priceCalculate, setPriceCalculate] = React.useState(null);
  const [filters, setFilters] = React.useState({});
  const [sort, setSort] = React.useState("priceAsc");
  const [filterOpen, setFilterOpen] = React.useState(false);
  const [pendingBookingData, setPendingBookingData] = React.useState(null);

  const dekstop = useMediaQuery("(min-width:900px)");
  const { t } = useTranslation();
  const getLanguage = typeof window !== undefined && localStorage.getItem("@wirasana_lang");
  const currentLanguage = JSON.parse(getLanguage);

  const pickupDate = moment(data?.pickup_date).format("YYYY-MM-DD HH:mm:ss");
  const endDate = moment(data?.dropoff_date).format("YYYY-MM-DD HH:mm:ss");

  const dlvPrice = priceCalculate?.prices?.find((v) => v.type === "delivery_fee");
  const pcpPrice = priceCalculate?.prices?.find((v) => v.type === "pickup_fee");

  const dropoffDate =
    data?.type !== "transfer_service"
      ? endDate
      : moment(pickupDate).set({ hour: 23, minute: 59, second: 59 }).format("YYYY-MM-DD HH:mm:ss");

  let condition = {};
  condition =
    data?.type === "tour"
      ? { hour: parseInt(data.tourPackage) }
      : data?.type === "transfer_service"
      ? { areas: JSON.parse(data?.dropoff_location_json) }
      : {};

  const { items: carsData, isLoading: carLoading } = useFetch({
    module: `cars/available?datetimeFrom=${pickupDate}&datetimeTo=${dropoffDate}&priceType=${data?.type}${
      data?.type !== "self_drive" ? "&condition=" + encodeURIComponent(JSON.stringify(condition)) : ""
    }`,
    enabled: true,
  });

  const findPrice = usePost({
    module: `v1/car-prices/calculate`,
  });

  const createPayment = usePost({
    module: "xendit/invoice",
  });

  const outOftownDatas = React.useMemo(() => {
    const result = {};
    dateUsage?.outOfTown?.forEach((item) => {
      const { date, zone } = item;
      if (!result[date]) {
        result[date] = [];
      }
      result[date].push(...zone);
    });
    return result;
  }, [dateUsage]);

  const outOfIslandDatas = React.useMemo(() => {
    const result = [];
    dateUsage?.outOfIsland?.forEach((item) => {
      result.push(item);
    });
    return result;
  }, [dateUsage]);

  React.useEffect(() => {
    if (data?.car?.id) {
      const body = {
        datetimeFrom: pickupDate,
        type: data?.type,
        carId: data?.car?.id,
        datetimeTo: dropoffDate,
        additionalItems: aditionalItem,
      };

      if (data?.type === "self_drive") {
        body.delivery_location = JSON.parse(data?.pickup_location_json);
        body.location = JSON.parse(data?.dropoff_location_json);
        if (outOfIslandDatas) {
          body.outOfIslandDatas = outOfIslandDatas;
        }
      }
      if (data?.type === "tour") {
        body.hour = parseInt(data?.tourPackage);
        body.outOfTownDates = outOftownDatas;
      }
      if (data?.type === "transfer_service") {
        body.location = JSON.parse(data?.dropoff_location_json);
      }

      findPrice.mutateAsync(body).then((res) => {
        const totalCalc = res?.data;
        setPriceCalculate(totalCalc);
      });
    }
  }, [data, aditionalItem, outOftownDatas, dateUsage]);

  const { items: pricesData } = useFetch({
    module: "car-prices",
    enabled: true,
  });

  const cars = carsData?.data;
  const prices = pricesData?.data;

  const createCustomer = usePost({ module: "customers" });
  const createBooking = usePost({ module: "bookings" });
  const upLoadImage = usePost({
    module: "storage",
  });
  const { uploadImageLoading, uploadMultipleImage } = usePostMultipleImage();

  const navigate = useNavigate();

  const _onSelectCar = (values) => {
    setData({ ...data, car: values });
    setDateUsage({ inTown: [], outOfTown: [] });
    setModal(true);
  };
  const totalSum = sumCalculatePrice(priceCalculate?.prices || []);

  const _onSubmit = async (cs) => {
    Notiflix.Loading.hourglass();
    try {
      const idImg = cs.identity_image ? await upLoadImage.mutateAsync(cs.identity_image) : null;
      const drvImg =
        data?.type === "self_drive" && cs.driving_license ? await upLoadImage.mutateAsync(cs.driving_license) : null;
      const flightImg = await uploadMultipleImage(cs.flight);
      const hotelImg = await uploadMultipleImage(cs.hotel);

      const rebuiltFlight = flightImg?.map((item) => item?.value?.data?.url) || [];
      const rebuiltHotel = hotelImg?.map((item) => item?.value?.data?.url) || [];

      const customerData = {
        ...cs,
        identity_image: [idImg?.data?.url],
        ...(drvImg ? { driving_license: [drvImg?.data?.url] } : {}),
      };

      const resCustomer = await createCustomer.mutateAsync(customerData);
      const csId = resCustomer?.data?.data?.id;

      const dataBooking = {
        type: data?.type,
        tour_package: data?.tourPackage,
        car_id: data?.car.id,
        customer_id: csId,
        price: totalSum,
        pickup_date: data?.pickup_date,
        dropoff_date: data?.dropoff_date,
        pickup_location: data?.pickup_location,
        dropoff_location: data?.dropoff_location,
        pickup_location_json: data?.pickup_location_json,
        dropoff_location_json: data?.dropoff_location_json,
        pickup_price: dlvPrice?.price || 0,
        dropoff_price: pcpPrice?.price || 0,
        additional_items: cs?.additional_items,
        notes: cs?.notes,
        price_calculate_data: priceCalculate,
        auto_generate_invoice: "true",
        additional_informations: {
          ...cs?.additional_informations,
          flightReservation: rebuiltFlight,
          hotelReservation: rebuiltHotel,
        },
      };

      setPendingBookingData(dataBooking);
      setModal(false);
      setOpenPaymentPopUp(true);

      Notiflix.Loading.remove();
    } catch (error) {
      console.error(error);
      Notiflix.Loading.remove();
      Notiflix.Report.failure("Failed", "Please try again", "OK");
    }
  };

  const updatePaymentLink = async (bookingId, paymentLink) => {
    return await api.put(`/bookings/${bookingId}/payment-link`, {
      payment_link: paymentLink,
    });
  };

  const handleConfirmPayment = async () => {
    if (!pendingBookingData) return;

    Notiflix.Loading.hourglass();

    try {
      const booking = await createBooking.mutateAsync(pendingBookingData);
      const newBooking = booking?.data?.data;
      const invoiceNumber = newBooking?.booking_invoice?.invoice?.number;

      const xenditData = {
        amount: newBooking?.total_price,
        invoice_number: invoiceNumber,
        customer: {
          id: newBooking?.customer?.id,
          email: newBooking?.customer?.email,
          surename: newBooking?.customer?.name,
          phone: newBooking?.customer?.phone,
        },
      };

      const xenditResponse = await createPayment.mutateAsync(xenditData);
      const paymentLink = xenditResponse?.data?.data?.invoice_url;

      setPaymentLink(paymentLink);

      await updatePaymentLink(newBooking.id, paymentLink);

      Notiflix.Loading.remove();
      Notiflix.Report.success("Booking Created", "Payment link has been generated successfully!", "OK");
    } catch (error) {
      console.error(error);
      Notiflix.Loading.remove();
      Notiflix.Report.failure("Transaction failed", "Please try again later", "OK");
    }
  };

  const filteredCars = cars?.filter((item) => {
    const values = Object.values(item);
    const searchString = values.join("###").toLowerCase();
    const matchesSearch = filters.search ? searchString.includes(filters.search.toLowerCase()) : true;

    const newPrices = prices?.filter((p) => p.car_id === item?.id);
    const priceByType = newPrices?.find((v) => {
      if (data?.type === "self_drive") {
        return v?.type === "self_drive" && v.condition_type === "default";
      } else if (data?.type === "tour") {
        return v?.type === "tour" && v.condition_type === "default" && v.condition?.hour === Number(data.tourPackage);
      }
      return false;
    });
    const carPrice = priceByType?.price || 0;
    const matchesPrice =
      filters.price?.length === 2 ? carPrice >= filters.price[0] && carPrice <= filters.price[1] : true;

    const matchesPassenger =
      filters.passengers?.length > 0 ? filters.passengers.includes(item.additional_informations?.seat) : true;

    const matchesTransmission =
      filters.transmission?.length > 0 ? filters.transmission.includes(item.transmision) : true;

    const matchesDrivetrain = filters.drivetrain?.length > 0 ? filters.drivetrain.includes(item.drive_system) : true;

    return matchesSearch && matchesPrice && matchesPassenger && matchesTransmission && matchesDrivetrain;
  });

  const getCarPrice = (car) => {
    const newPrices = prices?.filter((p) => p.car_id === car?.id);
    const priceByType = newPrices?.find((v) => {
      if (data?.type === "self_drive") {
        return v?.type === "self_drive" && v.condition_type === "default";
      } else if (data?.type === "tour") {
        return v?.type === "tour" && v.condition_type === "default" && v.condition?.hour === Number(data.tourPackage);
      }
      return false;
    });
    return priceByType?.price || 0;
  };

  const sortedCars = React.useMemo(() => {
    if (!filteredCars) return [];

    const carsCopy = [...filteredCars];

    switch (sort) {
      case "priceAsc":
        return carsCopy.sort((a, b) => {
          const priceA = getCarPrice(a);
          const priceB = getCarPrice(b);
          return priceA - priceB;
        });
      case "priceDesc":
        return carsCopy.sort((a, b) => {
          const priceA = getCarPrice(a);
          const priceB = getCarPrice(b);
          return priceB - priceA;
        });
      case "nameAsc":
        return carsCopy.sort((a, b) => a.name.localeCompare(b.name));
      case "nameDesc":
        return carsCopy.sort((a, b) => b.name.localeCompare(a.name));
      default:
        return carsCopy;
    }
  }, [filteredCars, sort, prices, data]);

  React.useEffect(() => {
    if (!data) {
      navigate("/");
    }
  }, [data]);

  const handleApplyFilters = (f) => {
    setFilters(f);
  };

  const handleSortChange = (val) => {
    setSort(val);
  };

  return (
    <>
      <section className="relative min-h-screen bg-gradient-to-b from-slate-50 to-white">
        <Navbar2 />
        <HeroPages name={t("select_vehicle")} />
        <InputBox sort={sort} setFilterOpen={() => setFilterOpen(true)} handleSortChange={handleSortChange} />
        <FilterModal open={filterOpen} onClose={() => setFilterOpen(false)} onApply={handleApplyFilters} />
        <div className="container px-4 py-12 mx-auto md:px-8 md:py-32">
          {!sortedCars?.length && !carLoading ? (
            <NoFoundVehicles title={`No cars available on ${data?.pickup_date} - ${data?.dropoff_date}`} />
          ) : null}

          {carLoading ? (
            <Loading />
          ) : (
            <div className="grid grid-cols-1 gap-6 my-24 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
              {sortedCars?.map((item, idx) => {
                const newPrices = prices?.filter((p) => {
                  return p.car_id === item?.id;
                });
                const priceByType = newPrices?.find((v) => {
                  if (data?.type === "self_drive") {
                    return v?.type === "self_drive" && v.condition_type === "default";
                  } else if (data?.type === "tour") {
                    return (
                      v?.type === "tour" &&
                      v.condition_type === "default" &&
                      v.condition?.hour === Number(data.tourPackage)
                    );
                  }
                });

                return (
                  <div
                    key={idx}
                    className="group bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-slate-100 hover:border-[#f5272b]/30"
                  >
                    {/* Image Section */}
                    <div className="relative flex items-center justify-center w-full h-56 overflow-hidden bg-white">
                      <img
                        src={item?.image_urls[0] || PlaceholderImg}
                        alt={item.name}
                        className="object-contain w-full h-full transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute top-4 right-4">
                        <Link
                          to={`/detail-vehicle`}
                          state={{
                            car: item,
                            prices: newPrices,
                            from: "select-vehicle",
                          }}
                          className="flex items-center gap-2 px-4 py-2 bg-white/90 backdrop-blur-sm hover:bg-[#f5272b] text-slate-800 hover:text-white rounded-md shadow-lg transition-all duration-300 text-sm font-semibold"
                        >
                          <i className="fa-solid fa-circle-info"></i>
                          <span>{t("more_info")}</span>
                        </Link>
                      </div>
                    </div>

                    {/* Content Section */}
                    <div className="p-6 space-y-5">
                      {/* Title */}
                      <div>
                        <h3 className="mb-1 text-2xl font-bold text-slate-900">{capitalFirstLetter(item.name)}</h3>
                      </div>

                      {/* Price Section */}
                      <div className="p-4 border rounded-lg bg-gradient-to-r from-slate-50 to-transparent border-slate-200">
                        {data?.type === "self_drive" ? (
                          <div className="space-y-1">
                            <p className="text-sm font-medium text-slate-600">{t("daily_rate_from")}</p>
                            <p className="text-3xl font-bold text-[#f5272b]">
                              {currencyFormat(priceByType?.price || 0)}
                            </p>
                          </div>
                        ) : data?.type === "tour" ? (
                          <div className="space-y-1">
                            <p className="text-sm font-medium text-slate-600">{t("daily_rate_from")}</p>
                            <p className="text-3xl font-bold text-[#f5272b]">
                              {currencyFormat(priceByType?.price || 0)}
                              <span className="ml-2 text-base font-normal text-slate-500">
                                /{Number(data.tourPackage)}
                                {currentLanguage?.value === "id" ? "Jam" : "h"}
                              </span>
                            </p>
                          </div>
                        ) : (
                          <div>
                            <p className="text-[#f5272b] text-sm font-semibold">{t("the_price_varies")}</p>
                          </div>
                        )}

                        <div className="pt-3 mt-3 border-t border-slate-200">
                          <div className="flex items-start gap-2 text-sm">
                            <i className="fa-solid fa-circle-check text-green-600 mt-0.5"></i>
                            <div>
                              <span className="font-semibold text-slate-900">{t("includes")}: </span>
                              <span className="text-slate-600">{t("isurances_etc")}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Specifications Grid */}
                      <div className="grid grid-cols-2 gap-3">
                        <div className="flex items-center gap-3 p-3 border rounded-md bg-slate-50 border-slate-200">
                          <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 bg-white rounded-lg shadow-sm">
                            <i className="fa-solid fa-tag text-[#f5272b]"></i>
                          </div>
                          <div className="min-w-0">
                            <p className="text-xs font-medium text-slate-500">Brand</p>
                            <p className="text-sm font-semibold truncate text-slate-900">
                              {capitalFirstLetter(item.brands)}
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center gap-3 p-3 border rounded-md bg-slate-50 border-slate-200">
                          <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 bg-white rounded-lg shadow-sm">
                            <i className="fa-solid fa-gears text-[#f5272b]"></i>
                          </div>
                          <div className="min-w-0">
                            <p className="text-xs font-medium text-slate-500">Trans.</p>
                            <p className="text-sm font-semibold truncate text-slate-900">
                              {capitalFirstLetter(item.transmision)}
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center gap-3 p-3 border rounded-md bg-slate-50 border-slate-200">
                          <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 bg-white rounded-lg shadow-sm">
                            <i className="fa-solid fa-car text-[#f5272b]"></i>
                          </div>
                          <div className="min-w-0">
                            <p className="text-xs font-medium text-slate-500">Drive</p>
                            <p className="text-sm font-semibold truncate text-slate-900">{item?.drive_system}</p>
                          </div>
                        </div>

                        <div className="flex items-center gap-3 p-3 border rounded-md bg-slate-50 border-slate-200">
                          <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 bg-white rounded-lg shadow-sm">
                            <i className="fa-solid fa-users text-[#f5272b]"></i>
                          </div>
                          <div className="min-w-0">
                            <p className="text-xs font-medium text-slate-500">Seats</p>
                            <p className="text-sm font-semibold text-slate-900">
                              {item?.additional_informations?.seat} {t("passenger")}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Book Button */}
                      <button
                        onClick={() => _onSelectCar(item, newPrices)}
                        className="w-full px-6 py-4 bg-[#f5272b] hover:bg-red-700 text-white font-bold text-lg rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 group"
                      >
                        <span className="flex items-center justify-center gap-3">
                          {t("book_ride").toUpperCase()}
                          <i className="transition-transform fa-solid fa-arrow-right group-hover:translate-x-1"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* CTA Banner */}
        {/* <div className="relative py-16 overflow-hidden bg-gradient-to-r from-slate-800 to-slate-900 md:py-20">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#f5272b] rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#f5272b] rounded-full blur-3xl"></div>
          </div>

          <div className="container relative z-10 px-4 mx-auto md:px-8">
            <div className="max-w-4xl mx-auto space-y-6 text-center">
              <h2 className="text-3xl font-bold leading-tight text-white md:text-4xl lg:text-5xl">
                {t("book_car_by_getting")}
              </h2>
              <a
                href="tel:03612860066"
                className="inline-flex items-center gap-4 px-8 py-5 bg-[#f5272b] hover:bg-red-700 text-white font-bold text-xl rounded-lg shadow-2xl hover:shadow-[#f5272b]/50 transition-all duration-300"
              >
                <i className="text-2xl fa-solid fa-phone"></i>
                <span>(0361) 286-066</span>
              </a>
            </div>
          </div>
        </div> */}

        <Footer />
      </section>

      <CustomerForm
        onSubmit={_onSubmit}
        priceCalculate={priceCalculate}
        disabled={upLoadImage?.isLoading || createBooking.isLoading || createCustomer.isLoading || uploadImageLoading}
      />

      <div onClick={() => setModal(false)} className={`modal-overlay ${modal ? "active-modal" : ""}`}></div>

      <Modal
        open={openPaymentPopUp}
        showCloseIcon={true}
        onClose={() => {}}
        closeIcon={
          <div
            onClick={() => {
              setOpenPaymentPopUp(false);
              setModal(false);
            }}
            className="close-icon"
          >
            <i className="fa-solid fa-x" />
          </div>
        }
        styles={{
          root: { zIndex: 9999999991 },
          modal: {
            overflow: "hidden",
            width: dekstop ? "500px" : "95%",
            height: "95%",
          },
        }}
      >
        {!paymentLink ? (
          <PaymentPrompt t={t} handleConfirmPayment={handleConfirmPayment} totalAmount={totalSum} />
        ) : (
          <iframe title="Payment Pop-up" src={paymentLink} style={{ border: "none", height: "100%", width: "100%" }} />
        )}
      </Modal>
    </>
  );
}

export default SelectVehicle;
